<template>
  <button :type="type" :disabled="disabled" @click="$emit('click')">
    <div class="flex items-center">
      <svg
        v-if="loading"
        class="w-4 h-4 mr-2 text-white animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    type: String,
    disabled: Boolean,
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="postcss" scoped>
button {
  @apply block font-eurostile font-bold text-white text-base py-2 px-3 rounded-sm leading-tight;
  background: linear-gradient(
    145deg,
    theme("colors.darkblue") 0%,
    theme("colors.lightblue") 100%
  );
}

button:focus {
  @apply outline-none;
}

button:focus {
  @apply shadow-outline;
}

button:hover {
  @apply bg-purple-400;
}

button:disabled {
  cursor: not-allowed;
  filter: grayscale(100%);
  opacity: 0.4;
}
</style>
